import React, { FC } from 'react';
import { withWebHeader } from '@24i/nxg-sdk-smartott/src/navigation/components/withWebHeader';
import { CleengPaymentMethod } from '../../../CleengPaymentMethod';

const CleengPaymentMethodScreenView: FC = () => {
    return <CleengPaymentMethod />;
};

export default withWebHeader(CleengPaymentMethodScreenView);
